import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ISport } from './sport.interface';

@Component({
    selector: 'mlp-ng-sport',
    templateUrl: './sport.component.html',
    styleUrls: ['./sport.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SportSharedComponent {
    @Input() sport: ISport;
    @Input() active = false;

    get faIcon() { return (this.active) ? 'check-circle' : 'plus-circle'; }
}
